var exports = {
  "i": "disconnectedPullRequestLink__HSMP54",
};

module.exports = exports;
